import { BrandMark } from '../../../components/BrandMark';
import { SCRAPE_BENCHMARK, type BenchService } from '../../../data/scrapeBenchmark';
import { usd, usdWhole } from '../../../lib/format';
import { m } from '../../../paraglide/messages';

/** The plan a price is read with, in the reader's language. */
const planNote = (plan: BenchService['plan']) =>
  plan === undefined ? null : plan === 'hobby' ? m.scrape_router_plan_hobby() : m.scrape_router_plan_monthly({ price: usdWhole(plan.monthlyUsd) });

/** One service's benchmark result: its own logo (ours is the AnyAPI mark)
 *  beside its own score and price, never beside one of our sources. */
export const BenchmarkCard = ({ service }: { service: BenchService }) => {
  const note = planNote(service.plan);
  return (
    <li
      className={`flex min-w-0 flex-col gap-2 rounded-12 border p-3.5 ${
        service.self ? 'col-span-2 border-accent-line bg-accent-soft s720:col-span-1' : 'border-rule bg-surface'
      }`}
    >
      <span className="flex min-w-0 items-start gap-2">
        {service.self || !service.logo ? (
          <BrandMark size={16} className="shrink-0" />
        ) : (
          <img src={service.logo} alt="" width={16} height={16} loading="lazy" className="shrink-0 rounded-4 object-contain" />
        )}
        <span className={`text-13 leading-snug ${service.self ? 'font-semibold text-text' : 'text-text-2'}`}>{service.name}</span>
      </span>
      <span className="mono whitespace-nowrap">
        <span className={`text-30 font-semibold ${service.self ? 'text-accent' : 'text-text'}`}>{service.total}</span>
        <span className="text-12 text-text-3">/{SCRAPE_BENCHMARK.pages}</span>
      </span>
      <span className="inline-flex flex-wrap items-baseline gap-x-1.5">
        <span className={`mono text-14 ${service.self ? 'font-semibold text-accent' : 'text-text-2'}`}>
          {service.priceAtMost ? <span className="text-11 text-text-3">{m.scrape_router_at_most()} </span> : null}
          {usd(service.costPer1kUsd)}
        </span>
        {note ? <span className="whitespace-nowrap text-11 text-text-3">{note}</span> : null}
      </span>
    </li>
  );
};
